import {DataTable} from '../ui/DataTable';

export function DocumentUploadSelection({files,destination,disabled,onRemove}:{files:File[];destination:string;disabled:boolean;onRemove:(file:File)=>void}){
 if(!files.length)return null;
 const rows=files.map((file,index)=>({file,index}));
 return <div className="document-upload-selection"><DataTable caption={<span className="sr-only">Selected original files</span>}
  scrollLabel="Selected original files" rows={rows} getRowKey={row=>String(row.index)} pageSize={18}
  rowHeader={{id:'file',header:'File',render:row=><span className="document-selected-name">{row.file.webkitRelativePath||row.file.name}</span>}}
  columns={[
   {id:'size',header:'Size',align:'right',render:row=>row.file.size.toLocaleString()+' bytes'},
   {id:'destination',header:'Destination',render:()=>destination},
   {id:'validation',header:'Checks',render:()=> 'Checked when uploaded'},
   {id:'state',header:'Upload state',render:()=> 'Not uploaded'},
   {id:'remove',header:'Selection',render:row=><button type="button" className="secondary" disabled={disabled} aria-label={'Remove '+row.file.name+' from selection'} onClick={()=>onRemove(row.file)}>Remove</button>},
  ]}/></div>;
}
